// Clinics whose hero is a wide/branded photo (team shot, logo). We show the full
// image (object-contain) over a per-clinic fill so the letterbox bands blend
// nicely. `blur` adds a soft blurred copy of the photo behind it; when false we
// use a clean solid color band (best when the photo edges are a solid color).
export const HERO_FILL = {
  "Supreme Dental": { bg: "bg-black", blur: false },
  "Rumo Dental Group": { bg: "bg-neutral-300", blur: true },
  "Good Smile Dental Clinic": { bg: "bg-[#8a7565]", blur: true },
};
